var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOtherCallIcon = function SvgOtherCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(-1167 -271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(1167 271)",
    fill: "#f4f4f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "store_FILL0_wght300_GRAD-25_opsz20",
    d: "M155.485-751.975v-1.178h13.491v1.178Zm.058,12.808v-5.245h-1.312v-1.178l1.254-4.656h13.491l1.254,4.656v1.178h-1.312v5.245h-1.178v-5.245H163.1v5.245Zm1.178-1.178h5.206v-4.067h-5.206Zm-1.289-5.245h0Zm0,0h13.6l-.917-3.478h-11.77Z",
    transform: "translate(1016.769 1029.161)",
    fill: "#3b3b3b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtherCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/otherCallIcon.099247d1.svg";
export { ForwardRef as ReactComponent };